<template>
  <div class="container-fluid">
    <div class="banner">
      <div style="text-align: center">
        <img src="./images/contact_banner.png" alt style="max-width: 1600px;width: 90%;" />
        <img src="./images/contact_banner_title.png" alt />
      </div>
    </div>
    <div class="contact_info container">
      <p>
        <img src="./images/contact.png" alt />
      </p>
      <ul class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <li>
          <p>
            <a href="mailto:contact@multiverseinc.com">
              <font-awesome-icon :icon="['fas', 'comment-dots']" />
              {{$t("contact_view.Regular")}}： {{$t("contact_view.Regular_email")}}
            </a>
          </p>
        </li>
        <li>
          <p>
            <a :href="$t('contact_view.Public_email')">
              <font-awesome-icon :icon="['fas', 'share-alt-square']" />
              {{$t("contact_view.Public")}}： {{$t("contact_view.Public_email")}}
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href="mailto:careers@multiverseinc.com">
              <font-awesome-icon :icon="['fas', 'user-circle']" />
              {{$t("contact_view.Human")}}： {{$t("contact_view.Human_email")}}
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href="mailto:freeman@multiverseinc.com">
              <font-awesome-icon :icon="['fas', 'briefcase']" />
              {{$t("contact_view.Business")}}： {{$t("contact_view.Business_email")}}
            </a>
          </p>
        </li>
      </ul>
      <ul class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <li>
          <p>
            <a :href="facebook">
            <font-awesome-icon :icon="['fab', 'facebook-f']" /> {{showFacebook}}</a>
          </p>
        </li>
        <li>
          <p>
            <a :href='twitter'>
            <font-awesome-icon :icon="['fab', 'twitter']" /> {{showTwitter}}</a>
          </p>
        </li>
        <li>
          <p>
            <a :href="linkedin">
            <font-awesome-icon :icon="['fab', 'linkedin']" /> {{showLinkedin}}</a>
          </p>
        </li>
        <li>
          <p>
            <a :href="instagram">
            <font-awesome-icon :icon="['fab', 'instagram']" /> {{showInsgram}}</a>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import globle from '@/assets/globle.js'
export default {
  data() {
    return {
      facebook: globle.facebook,
      twitter: globle.twitter,
      linkedin: globle.linkedin,
      instagram: globle.instagram,
    };
  },
  computed:{
    showFacebook(){
      return this.facebook.substr(8);
    },
    showTwitter(){
      return this.twitter.substr(8);
    },
    showLinkedin(){
      return this.linkedin.substr(8);
    },
    showInsgram(){
      return this.instagram.substr(8);
    }
  }
};
</script>
}
